// Copyright (c) Docugami, Inc. All rights reserved.
import React, { useState } from "react";
import { homeGray } from "../presentation/AppStyles";
import styled from 'styled-components';
import { FontIcon } from "@fluentui/react";
import { IconContainer } from "components/myContentExplorer/NavigationItemGroup";

const ExpandedTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 13px;
`;

const TitleText = styled.span`
    margin: 3px;
    cursor: pointer;
`;

const TitleTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${homeGray};
    cursor: pointer;
`;

const BodyText = styled.span<{hidden: boolean}>`
    margin-left: 20px;
    color: ${homeGray};
    height: ${props => props.hidden ? '0px' : 'default'};
    transition: height 2s linear 1s;
    padding-bottom: 15px;
`;

export interface ExpandedTextProps {
    title: string;
    text: string;
}

export const ChevronExpandedText = (props: ExpandedTextProps): JSX.Element => {
    const [ expandedTextHidden, setExpandedTextHidden ] = useState(true);

    return (
        <ExpandedTextContainer>
            <TitleTextContainer onClick={() => setExpandedTextHidden(v => !v)} >
                <FontIcon iconName={"Info"} />
                <TitleText>{props.title}</TitleText>
                <IconContainer isExpanded={!expandedTextHidden}>
                    <FontIcon iconName={"ChevronRight"} />
                </IconContainer>
            </TitleTextContainer>
            <BodyText hidden={expandedTextHidden}>{props.text}</BodyText>
        </ExpandedTextContainer>
    );
}